import { NgModule } from '@angular/core';
// import { AngularFireModule, FirebaseOptionsToken } from 'angularfire2';
// import { AngularFireDatabaseModule } from 'angularfire2/database';
// import { AngularFireAuthModule } from 'angularfire2/auth';

// import { SocialLoginModule, AuthServiceConfig } from "angularx-social-login";
// import { GoogleLoginProvider} from "angularx-social-login";
// import { ConfigService } from "@ngxsuit";

// export function GoogleLoginConfigProvide(configService: ConfigService) {
//     let configs = new AuthServiceConfig([
//         {
//           id: GoogleLoginProvider.PROVIDER_ID,
//             provider: new GoogleLoginProvider(configService.get('google-client-id'), {
//             scope: 'profile email'
//           })
//         }]);

//     return configs;
// }

// export function FirebaseConfigProvide(configService: ConfigService) {
//     // return configService.get('firebase');
//     return window["firebaseConfigs"];
// }

@NgModule({
    imports: [
        // AngularFireModule,
        // AngularFireDatabaseModule,
        // AngularFireAuthModule,
        // SocialLoginModule
    ],
    providers: [
        // {
        //     provide: AuthServiceConfig,
        //     useFactory: GoogleLoginConfigProvide,
        //     deps: [ConfigService]
        // },
        // {
        //     provide: FirebaseOptionsToken,
        //     useFactory: FirebaseConfigProvide,
        //     deps: [ConfigService]
        // }
      ]
})
export class ExportModule { }
